import { createAction, props } from '@ngrx/store';
import { LeadFilters } from '@shared/models/lead-filters';

export const setLeadFilters = createAction('[Leads] Set Lead Filters', props<{ filters: LeadFilters | undefined }>());
